<template>
  <v-dialog v-model="getFormTooLongViewer" max-width="45%">
    <v-card>
      <v-card-title class="justify-center text-h4 pb-7 font-weight-bold ma-0">
        {{ $t("header") }}
      </v-card-title>
      <div style="position: absolute; align-self: end; right: 0; top: 0">
        <v-btn icon class="mr-5 mt-3" @click="closeDialog">
          <v-icon color="red" x-large>mdi-window-close</v-icon>
        </v-btn>
      </div>
      <v-divider></v-divider>

      <v-card-text align="center" class="pa-5 mt-5 text-h6">
        <div v-if="getKioskLocation !== 'MDJ'">
          {{ $t("message1") }}
        </div>

        <div v-else>
          {{ $t("message2") }}
        </div>
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn v-if="this.getKioskLocation !== 'MDJ'"
          color="secondary"
          @click="showMap($t('mapName'))"
          class="mb-3"
          width="50%"
        >
          <v-icon left dark medium> mdi-map-marker-radius </v-icon>
          <!-- {{ trimmedName(map) }} -->
          {{ $t("mapInstruction") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  name: "formTooLongViewer",
  computed: {
    ...mapGetters([
      "getFormTooLongViewer",
      "getKioskProfile",
      "getSessionId",
      "getKioskLocation",
    ]),
  },
  methods: {
    closeDialog() {
      console.log("getting here to close the dialog?");
      this.$store.commit("setFormTooLongViewer", false);
    },
    showMap(map) {
      this.closeDialog();
      let date = new Date();
      this.$i18n.t("maps").forEach((mapper) => {
        let floorName = this.$i18n
          .t("floors")
          .filter((floor) => floor.floorNumber === mapper.mapFloor);
        if (mapper.mapName.toLowerCase().trim() === map.toLowerCase().trim()) {
          this.$store.dispatch("openImageViewer", {
            name: mapper.mapName,
            url: mapper.mapImage,
            floor: floorName[0].floorName,
          });
          this.$store.dispatch("avatarTalk", mapper.speech);

          this.tab = mapper.mapFloor - 1;
          this.$store.dispatch("addSessionDataToStrapi", {
            applicationId: this.getKioskProfile.data().applicationId,
            actionType: "Touch",
            applicationSessionId: this.getSessionId,
            timeStamp: date.toISOString(),
            sessionPayload: {
              module: "Maps",
              action: "View Map",
              response: mapper.mapName,
              timeStamp: date.toISOString(),
            },
          });

          this.$store.dispatch("addInteractionToPostgres", {
            actionType: "Interaction",
            actionPayload: {
              module: "Maps",
              action: "View Map",
              response: mapper.mapName,
              timeStamp: date.toISOString(),
            },
          });
        }
      });
    },
  },
};
</script>
<i18n>
{
    "en": {
        "header": "Long Form — Please Use ‘View/Email Form’",
        "message1": "This form is too long to comfortably complete on this kiosk. Please visit the Law Library to access and complete this form.",
        "message2": "Please use the 'View/Email Form' option as this form is too long to be completed on this kiosk.",
        "mapName": "Law Library",
        "mapInstruction":"Directions to the Law Library"
        
      },
    "es":{
        "header": "Formulario demasiado largo para completar aquí",
    "message1": "Este formulario es demasiado largo para completarlo cómodamente en este quiosco. Si se encuentra en el Centro de Justicia de West Chester, diríjase a la Biblioteca Jurídica, en el cuarto piso, para acceder y completarlo.",
    "message2": "Si se encuentra en un MDJ o en cualquier otra ubicación, utilice la opción 'Ver/Enviar por correo electrónico' para completar este formulario en otro dispositivo.",
    "mapName": "Biblioteca Jurídica",
    "mapInstruction":"Cómo llegar a la Biblioteca de Derecho"
      }
  }
</i18n>
